import { IHttpServiceOptions } from "./ihttp-service-options";
import { localStorageHelper } from '@/utils';

export class TokenInterceptor<Options extends IHttpServiceOptions> {
  private jwt?: string;

  constructor(jwt?: string) {
    this.jwt = jwt || localStorageHelper.getItem('jwt') || undefined;
  }

  public setToken(token: string) {
    this.jwt = token;
    localStorageHelper.setItem('jwt', token);
  }

  public clearToken() {
    this.jwt = undefined;
    localStorageHelper.removeItem('jwt');
  }

  public attachToken(options?: Options): Options {
    if (!this.jwt) {
      return options || ({} as Options);
    }

    const headers: HeadersInit = options?.headers
      ? new Headers(options.headers)
      : new Headers();

    headers.set('Authorization', `Bearer ${this.jwt}`);

    return { ...options, headers } as Options;
  }

  public getToken(): string | undefined {
    return this.jwt;
  }
}
